import { render, staticRenderFns } from "./AllPolicy.vue?vue&type=template&id=3fede458&scoped=true&"
import script from "./AllPolicy.vue?vue&type=script&lang=ts&"
export * from "./AllPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./AllPolicy.vue?vue&type=style&index=0&id=3fede458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fede458",
  null
  
)

export default component.exports